// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const burgerMenuBtn = document.getElementById('js-menu-trigger');
const burgerMenuClose = document.getElementById('js-close-menu');
const burgerMenu = document.getElementById('burger-menu');
const itemsMenu = document.querySelectorAll('.primary-nav li');
const svgPaths = document.querySelectorAll(".color-animate");
const footerBldg = document.getElementById("js-animate-bldg");


(function(){

	window.onload = function() {
		onLoad();
	};

	// Main Nav
	burgerMenuBtn.addEventListener('click', () =>{
		burgerMenu.classList.add('open');
		document.body.classList.add('no-scroll');
	});

	burgerMenuClose.addEventListener('click', () =>{
		burgerMenu.classList.remove('open');
		document.body.classList.remove('no-scroll');
	});

	itemsMenu.forEach((itemMenu)=>{
		const itemSubmenu = itemMenu.querySelector('.submenu');
		if(itemSubmenu){
		
			const itemSubmenuHeight = itemSubmenu.clientHeight;
			itemSubmenu.parentNode.style.height = "0px";
			itemMenu.addEventListener('mouseenter',() => {
				itemMenu.classList.add('hover');
				itemSubmenu.parentNode.style.height = itemSubmenuHeight + "px";
			});
			itemMenu.addEventListener('mouseleave',() => {
				itemMenu.classList.remove('hover');
				itemSubmenu.parentNode.style.height = "0px";
			});
		}
	});


	// Mobile Form Date Fields
	const dateInputs = document.querySelectorAll('input[type="date"]');
	if (dateInputs) {
		dateInputs.forEach(function(input) {
			input.addEventListener('click', function() {
				this.classList.add('clicked');
			});
		});
	};	

	if(document.getElementById('languages')){
		document.getElementById('languages').addEventListener("change", function(e){
			changeLanguage(e.target.value);
		});
	}

	//Animate Building Footer when scrolled into view 
	const options = {
		rootMargin: '0px',
		threshold: 0.10,
	}

	const observer = new IntersectionObserver(observerElements, options);

	function observerElements(entries){
		entries.forEach(entry => {
			if(entry.isIntersecting){
				animateBuilding();
			}
		})
	}

	observer.observe(footerBldg);
	

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

const headerLogo = document.querySelector('.js-scroll-logo');
const header = document.getElementById('header');

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 40){
		if(!header.classList.contains('scroll')){
			header.classList.add('scroll');
			changeSrc(headerLogo.getElementsByTagName('img')[0]);
		};
	} else {
		if (document.getElementsByClassName('no-hero').length < 1) {
			if (header.classList.contains('scroll')) {
				header.classList.remove('scroll');
				changeSrc(headerLogo.getElementsByTagName('img')[0]);
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function onLoad() {
    if (document.getElementsByClassName('no-hero').length < 1) {
        scrollW();
    } else {
        document.getElementById('header').classList.add('scroll');
        changeSrc(headerLogo.getElementsByTagName('img')[0]);
    }

    window.addEventListener('scroll', function () {
        scrollW();
    });
}

function changeSrc(elem) {
	let target = elem.getAttribute('data-scroll');
	let currentSrc = elem.getAttribute('src');

	elem.setAttribute('src', target);
	elem.setAttribute('data-scroll', currentSrc);
}

function animateBuilding() {
	let currentIndex = 0;
	if(svgPaths.length > 0) {
		setInterval(() => {
			svgPaths.forEach(el => el.classList.remove("filled"));
			svgPaths[currentIndex].classList.add("filled");
			currentIndex = (currentIndex + 1) % svgPaths.length;
		}, 1800);
	};
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
	const menu = document.querySelector('#burger-menu');
	const isMenuVisible = menu && menu.classList.contains('open');
	const elements = document.querySelectorAll('.primary-nav li a, .secondary-navigation__item a');

	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}

document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();

	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('#burger-menu');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	};
});